import lodash from 'lodash'

// Sorts an array of token transfer events into an object of transfer event arrays,
// whose keys are the names of the tokens which are being transferred in the corresponding array.
// Transfers whose token addresses are not present in the tokensByAddress map are ignored.
//
// i.e. [{ address: '0x1', from, to, value }, { address: '0x2', from, to, value }]
//   -> { token1: [{ address: '0x1', from, to, value }], token2: [{ address: '0x2', from, to, value }] }

export default function getTransfersByTokenName(transfers, tokensByAddress) {
  const transfersByTokenName = lodash.groupBy(
    transfers,
    (transfer) => tokensByAddress.get(transfer.address.toLowerCase())?.name || 'UNKNOWN'
  )
  return lodash.omit(transfersByTokenName, 'UNKNOWN')
}
